import { obterSolicitacoesAsync, obterListaProdutosCotacaoAsync } from "../../services/solicitacaoService";

const atualizarSolicitacoes = async ({ commit }) => {
    const solicitacoes = await obterSolicitacoesAsync();
    commit('atualizarSolicitacoes', solicitacoes);
}

const atualizarProdutosCotacao = async ({ commit }) => {
    commit('atualizarCarregamentoProdutosCotacao', true);
    try {
        const produtosSolicitacao = await obterListaProdutosCotacaoAsync();
        commit('atualizarProdutosCotacao', produtosSolicitacao);
    } finally {
        commit('atualizarCarregamentoProdutosCotacao', false);
    }
}

const atualizarSolicitacao = ({ commit }, solicitacao) => {
    commit('atualizarSolicitacao', solicitacao);
}

const addSolicitacao = ({ commit }, solicitacao) => {
    commit('addSolicitacao', solicitacao);
}

const updateSolicitacao = ({ commit }, solicitacao) => {
    commit('updateSolicitacao', solicitacao);
}
const removeProdutoCotacao = ({ commit }, produto) => {
    commit('removeProdutoCotacao', produto);
}

export default {
    atualizarSolicitacoes,
    atualizarSolicitacao,
    atualizarProdutosCotacao,
    addSolicitacao,
    updateSolicitacao,
    removeProdutoCotacao,
}
